module.exports = require('./dist');


//////////////////
// WEBPACK FOOTER
// ./~/vue-croppie/index.js
// module id = 407
// module chunks = 0